import {
  collection,
  doc,
  getDocs,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  serverTimestamp
} from 'firebase/firestore';
import { db } from '../firebase';

const MEDIA_COLLECTION = 'media';

// Get all media
export async function getAllMedia() {
  const mediaRef = collection(db, MEDIA_COLLECTION);
  const q = query(mediaRef, orderBy('createdAt', 'desc'));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
}

// Get media for a specific course
export async function getMediaByCourseId(courseId) {
  const mediaRef = collection(db, MEDIA_COLLECTION);
  const q = query(mediaRef, where('course_id', '==', courseId));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
}

// Add new media
export async function addMedia({ courseId, courseName, mediaLink, mediaType }) {
  const mediaRef = collection(db, MEDIA_COLLECTION);
  const newMedia = {
    course_id: courseId,
    course_name: courseName,
    media_link: mediaLink,
    media_type: mediaType,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  };
  const docRef = await addDoc(mediaRef, newMedia);
  return { id: docRef.id, ...newMedia };
}

// Update existing media
export async function updateMedia(mediaId, { mediaLink, mediaType }) {
  const mediaRef = doc(db, MEDIA_COLLECTION, mediaId);
  const updates = {
    media_link: mediaLink,
    media_type: mediaType,
    updatedAt: serverTimestamp()
  };
  await updateDoc(mediaRef, updates);
  return { id: mediaId, ...updates };
}

// Delete media
export async function deleteMedia(mediaId) {
  const mediaRef = doc(db, MEDIA_COLLECTION, mediaId);
  await deleteDoc(mediaRef);
  return mediaId;
}

// Check if user is admin (uses separate admins collection for security)
export async function checkIsAdmin(userId) {
  if (!userId) return false;
  try {
    const adminRef = doc(db, 'admins', userId);
    const adminSnap = await getDoc(adminRef);
    return adminSnap.exists();
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
}

// Batch import media (for migration)
export async function batchImportMedia(mediaItems) {
  const results = [];
  for (const item of mediaItems) {
    try {
      const result = await addMedia({
        courseId: item.course_id,
        courseName: item.course_name,
        mediaLink: item.media_link,
        mediaType: item.media_type
      });
      results.push({ success: true, item: result });
    } catch (error) {
      results.push({ success: false, item, error: error.message });
    }
  }
  return results;
}
